// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch--3jBa_"};